import NewTicketProvider from './NewTicketContext';
import NewTicket from './NewTicket';

let Index = () => {
    return (
        <NewTicketProvider>
            <NewTicket />
        </NewTicketProvider>
    )
}

export default Index;